import React from "react";
import Style from "./Auth.module.scss";
import logo from "../imgs/YS-Logo-01.svg";

function Signup(props) {
    return (
        <>
            <img src={logo} alt="Yesterday Stories" className={Style.logo} />
            <h3 className={Style.heading}>Sign up</h3>
            <form onSubmit={props.signup} className={Style.form}>
                <input name="email" type="email" placeholder="Email" required className={Style.input} />
                <input name="password" type="password" placeholder="Choose Password" required className={Style.input} />
                <input name="check" type="password" placeholder="Confirm Password" required className={Style.input} />
                <button type="submit" className={Style.button}>Sign Up</button>
                <button type="button" onClick={props.change} className={Style.option}>Login &#62;</button>
            </form>
        </>
    );
}
export default Signup;
